import { Injectable } from '@angular/core';
import { LocationCode } from '../models/location.model';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { shareReplay, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private countriesCache$: Observable<LocationCode[]> | null = null;
  private provincesCache$: Observable<{ [key: string]: LocationCode[] }> | null = null;
  private statesProvincesCache: { [key: string]: Observable<LocationCode[]> } = {};

  constructor(private http: HttpClient) {}

  /**
   * Get all countries
   * Loads data from JSON file with caching
   */
  getCountries(): Observable<LocationCode[]> {
    if (!this.countriesCache$) {
      this.countriesCache$ = this.http.get<LocationCode[]>('/assets/data/countries.json').pipe(
        shareReplay(1)
      );
    }
    return this.countriesCache$;
  }

  /**
   * Get states/provinces for a specific country
   * Loads data from JSON file with caching
   */
  getStatesProvinces(countryCode: string): Observable<LocationCode[]> {
    if (!this.statesProvincesCache[countryCode]) {
      if (!this.provincesCache$) {
        this.provincesCache$ = this.http.get<{ [key: string]: LocationCode[] }>('/assets/data/provinces.json').pipe(
          shareReplay(1)
        );
      }
      
      this.statesProvincesCache[countryCode] = this.provincesCache$.pipe(
        map(allProvinces => allProvinces[countryCode] || [])
      );
    }
    return this.statesProvincesCache[countryCode];
  }

  /**
   * Clear all caches
   */
  clearCache(): void {
    this.countriesCache$ = null;
    this.provincesCache$ = null;
    this.statesProvincesCache = {};
  }
} 